import React from 'react';

import {UserProvider} from '@/auth';
import SystemConfigProvider from '@/SystemConfigProvider';
import {RouterSwitch} from '@/routes';
import ErrorBoundary from '@/ErrorBoundary';

const App = () => (
  <ErrorBoundary>
    <SystemConfigProvider>
      <UserProvider>
        <RouterSwitch />
      </UserProvider>
    </SystemConfigProvider>
  </ErrorBoundary>
);

export default App;
